import { render, staticRenderFns } from "./PriceIndicationsInfo.vue?vue&type=template&id=512b55b4"
import script from "./PriceIndicationsInfo.vue?vue&type=script&lang=js"
export * from "./PriceIndicationsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports